import { createSelector } from "reselect"
import { get, first, last, chain, find, isNil } from "lodash"

const EMPTY_OBJECT = {}

export const getForecastData = state => get(state, "global.data.compositeDailyForecast.data.model.simulation.dailyForecast", EMPTY_OBJECT)
const getForecasts = state => get(state, "global.data.compositeForecasts.data.forecasts", [])

const getCurrentForecastId = (_, props) => props.forecastId
const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate
const getSelectedDate = (_, props) => props.selectedDate

function formatForecast(forecast) {
  const count = forecast.length
  return chain(forecast)
    .map(({ date, expectedReturn }, index) => {
      if (!isNil(expectedReturn) || index === count - 1) {
        return ({
          date,
          factors: {
            expectedReturn: expectedReturn / 100,
          },
        })
      }
      return null
    })
    .filter(data => data)
    .value()
}

const getForecastEndDate = createSelector(
  [getForecastData],
  (data) => {
    return get(last(data), "date")
  },
)

export const getCurrentForecast = createSelector(
  [getForecasts, getCurrentForecastId],
  (forecasts, forecastId) => find(forecasts, ({ id }) => id === forecastId),
)

export const getForecast = createSelector(
  [getForecastData],
  (absolute) => formatForecast(absolute || {}),
)

export const getFilteredForecast = createSelector(
  [getForecast, getStartDate, getEndDate],
  (forecast, startDate, endDate) => {
    return forecast.filter((data) => {
      if (data.date >= startDate && data.date <= endDate) {
        return data
      } else {
        return null
      }
    })
  },
)

export const getFirst = createSelector(
  [getForecast],
  (forecast) => first(forecast),
)

export const getCurrent = createSelector(
  [getForecast],
  (forecast) => last(forecast),
)

export const getFirstForecastDate = createSelector(
  [getFilteredForecast],
  (forecast) => get(first(forecast), "date", null),
)

export const getAdjustedEndDate = createSelector(
  [getEndDate, getForecastEndDate],
  (endDate, forecastEndDate) => forecastEndDate < endDate ? forecastEndDate : endDate,
)

export const getAdjustedSelectedDate = createSelector(
  [getSelectedDate, getForecastEndDate],
  (selectedDate, forecastEndDate) => forecastEndDate < selectedDate ? forecastEndDate : selectedDate,
)
